import { NimAllowedActions, OrgMemberRole, PortalClientSettings } from '@nx-frontend/shared/types';

export function getTasksAllowedActions({
  readOnly,
  isMobileView,
  hasConsoleAccess,
  orgRole,
  clientSettings,
}: {
  readOnly: boolean;
  isMobileView: boolean;
  hasConsoleAccess: boolean;
  orgRole: OrgMemberRole;
  clientSettings?: PortalClientSettings;
}): NimAllowedActions {
  const canCreateTasks = orgRole !== OrgMemberRole.CLIENT || !!clientSettings?.createTasks;
  const canEditTasks = orgRole !== OrgMemberRole.CLIENT || !!clientSettings?.editTasks;
  const canCommentTasks = orgRole !== OrgMemberRole.CLIENT || !!clientSettings?.commentTasks;
  const canChangeTasksStatus = orgRole !== OrgMemberRole.CLIENT || !!clientSettings?.changeTasksStatus;
  return {
    boardCreate: !readOnly,
    boardUpdate: !readOnly && !hasConsoleAccess,
    boardDelete: !readOnly && !hasConsoleAccess,
    taskListCreate: !readOnly && canEditTasks,
    taskListDelete: !readOnly && !hasConsoleAccess,
    taskListUpdate: !readOnly && !hasConsoleAccess,
    // taskListConvertToBoard: flag && !isClient,
    taskListConvertToBoard: false,
    taskListNoteNavigate: !readOnly,
    taskListNoteUpdate: false,
    taskCreate: !readOnly && canCreateTasks,
    taskUpdate: !readOnly && canEditTasks,
    taskDelete: !readOnly && !hasConsoleAccess,
    taskDuplicate: !readOnly && canCreateTasks,
    taskCopyLink: false,
    taskConvertToTaskList: !readOnly && !hasConsoleAccess,
    taskDragNDrop: !readOnly && !isMobileView && canEditTasks,
    taskListDragNDrop: !readOnly && canEditTasks,
    taskStatusChange: !readOnly && canChangeTasksStatus,
    taskLabelAdd: !readOnly && canEditTasks,
    taskLabelDelete: !readOnly && canEditTasks,
    workspaceLabelCreate: !readOnly && !hasConsoleAccess,
    workspaceLabelUpdate: !readOnly && !hasConsoleAccess,
    workspaceLabelDelete: !readOnly && !hasConsoleAccess,
    taskAssigneeCreate: !readOnly && canEditTasks,
    taskAssigneeDelete: !readOnly && canEditTasks,
    taskReminderCreate: !readOnly && canEditTasks,
    taskReminderDelete: !readOnly && canEditTasks,
    taskCommentAdd: !readOnly && canCommentTasks,
    taskDescriptionEdit: !readOnly && canEditTasks,
    taskAttachmentAdd: !readOnly && canEditTasks,
    taskAttachmentDelete: !readOnly && canEditTasks,
    membersInvite: false,
    calendarDefaultViewChange: !readOnly && !hasConsoleAccess,
  };
}
